import { useEffect } from "react";
import CustomModel from "../Utility/CustomModel";
import parse from "html-react-parser";
const ShowCitation = ({ onClose, data }) => {
  console.log(data, "data");

  useEffect(() => {
    fetch(`${process.env.PUBLIC_URL}/custom.css`)
      .then((res) => res.text())
      .then((cssText) => {
        // prefix all rules with .my-component
        const prefixedCss = cssText.replace(
          /(^|\n)([^{\n]+){/g,
          `$1.my-component $2{`
        );
        const style = document.createElement("style");
        style.textContent = prefixedCss;
        document.head.appendChild(style);

        return () => document.head.removeChild(style);
      });
  }, []);
  function trimToWords(text, wordLimit = 20) {
    const words = text.split(/\s+/); // split by whitespace
    if (words.length <= wordLimit) return text;
    return words.slice(0, wordLimit).join(" ") + "...";
  }

  function renderElement(element) {
    if (!element) return null;

    if (element.nodeName === "REF") {
      const referenceText =
        element.querySelector("refoutput")?.textContent || "";
      const refTitle = element.querySelector("reftitle")?.textContent || "";

      return (
        <p>
          <span className="text-[#0f60efcc]">{refTitle}</span>:
          <span>{referenceText}</span>{" "}
        </p>
      );
    } else if (element.nodeName === "SEC") {
      const label = element.querySelector("label")?.textContent || "";
      const Title = element.querySelector("title1")?.textContent || "";
      const para = element.querySelector("p")?.textContent || "";

      return (
        <div className="text-left">
          <p className="text-[#0f60efcc] ">
            <span>{label}</span>.<span>{Title}</span>{" "}
          </p>{" "}
          {para && <p>{trimToWords(para)}...</p>}
        </div>
      );
    } else if (element.nodeName === "AFF") {
      const clone = element.cloneNode(true);
      const label = element.querySelector("label")?.textContent || "";
      clone.querySelectorAll("label").forEach((label) => label.remove());

      return (
        <p>
          <span className="text-[#0f60efcc] ">{label}.</span>{" "}
          <span>{clone.textContent.trim()}</span>{" "}
        </p>
      );
    } else {
      return parse(element.innerHTML);
    }
  }

  return (
    <CustomModel
      handleCancel={onClose}
      heading={"Citation"}
      width={"80%"}
      maxwidth={data.element.nodeName === "TABLE-WRAP" ? "1040px" : "600px"}
      minwidth={data.element.nodeName === "TABLE-WRAP"?"500px":"300px"}
      show={data.open}
    >
      <div
        className={`my-component  break-all pt-3 justify-center  flex min-h-[100px] max-h-[450px] overflow-auto   flex-col  w-full  ${
          data.element.nodeName === "FIG" ? "items-center" : ""
        } ${
          data.element.nodeName === "TABLE-WRAP" ||
          data.element.nodeName === "FIG"
            ? "text-center"
            : ""
        } `}
      >
        {renderElement(data.element)}
      </div>
    </CustomModel>
  );
};

export default ShowCitation;
